module.exports = __webpack_public_path__ + "me.0400ec95.svg";